import {Link} from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import {postApi, setCookie} from '../../utils/functions';

import Products from './products';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import { BsCheck2 } from "react-icons/bs";
import { FaFacebook, FaTwitch, FaMixcloud, FaYoutube } from "react-icons/fa6";

export default function Restream() {
  
  const [restream, setRestream] = useState([]);
  const [period, setPeriod] = useState(1);
  const [comparison, setComparison] = useState(null);
  
  useEffect(() => {

    async function loadServices() {
      let params = new URLSearchParams();
      params.append('product', 'restream');
      const x = await postApi(`/v3/frontend/index`, params);
      setRestream(x.data);
    }
    loadServices();
    window.scrollTo(0, 0);
  }, []);

  async function addToCart(product, period) {
    await setCookie('order', [{product, period}]);
    window.location.href = `https://portal.ultrastream.io/cart`;
  }

  function Comparison() {

    let header = [];
    let table = [
      [{title: 'price'}],
      [{title: 'Streamer information', colSpan: restream.filter(elem => ( elem.pricemonth === 0 && elem.stock > 0 ) || ( elem.pricemonth > 0 )).length+1}],
      [{title: 'Channels'}],
      [{title: 'Recording Per Stream'}],
      [{title: 'Recording Storage'}],
      [{title: 'Custom Destinations'}],
      [{title: 'Video Information', colSpan: restream.filter(elem => ( elem.pricemonth === 0 && elem.stock > 0 ) || ( elem.pricemonth > 0 )).length+1}],
      [{title: 'Video Quality'}],
      [{title: 'Frames Per Second'}],
      [{title: 'Video Bitrate'}],
      [{title: 'Encrypted RTMPS'}],
      [{title: 'Additional Tools', colSpan: restream.filter(elem => ( elem.pricemonth === 0 && elem.stock > 0 ) || ( elem.pricemonth > 0 )).length+1}],
      [{title: 'Cross-platform chat'}],
      //[{title: 'EmojiCrew'}],
      [{title: 'Stream analytics'}],
      [{title: 'Website embed player'}],
      [{title: ''}],
    ];

      //'', '', 'price', 'Get Started Easily'];

    restream.filter(elem => ( elem.pricemonth === 0 && elem.stock > 0 ) || ( elem.pricemonth > 0 )).map((e, i)=>{
      header.push({product: e.product, class: i===1?'bg-purple':'bg-purple-light'});

      //---- Pricing
      table[0][i+1] = {pricemonth: e.pricemonth, priceyear: e.priceyear};
      //---- Channels
      table[2][i+1] = {title: `${e.streams} Channels`};
      //---- Recordings
      table[3][i+1] = {title: `${e.option1} Hours`};
      //---- Storage
      table[4][i+1] = {title: `${e.option2} Day's`};
      //---- Destinations
      table[5][i+1] = {check: e.option3===1?true:false};
      
      //---- Video Quality
      table[7][i+1] = {title: `4K, 2160p`};
      //---- Video FPS
      table[8][i+1] = {title: `60 FPS`};
      //---- Video Bitrate
      table[9][i+1] = {title: `10000`};
      //---- Encrypted RTMPS
      table[10][i+1] = {check: true};

      //---- Cross-platform chat
      table[12][i+1] = {check: true};
      //---- EmojiCrew
      //table[13][i+1] = {check: true};
      //---- Stream analytics
      table[13][i+1] = {check: true};
      //---- Website embed player
      table[14][i+1] = {check: true};

      //---- Order Now
      table[15][i+1] = {order: e.id};
    });

    //console.log(table);
    
    /*for( let i in table ) {
      for( let j in restream ) {

      }
    }*/

    //console.log(header);

    return (
      <table>
        <thead>
          <tr>
            <th className="hide"></th>
            {header.map((e, i)=>{return(<th key={i} className={e.class}>{e.product}</th>)})}
          </tr>
        </thead>
        <tbody>
          {table.map((e, i)=>{
            return (
              <tr key={i}>
                {e.map((f, j)=>{
                  if( f?.colSpan ) return <td colSpan={f.colSpan} className="sep">{f.title}</td>
                  if( f?.title === 'price' ) return <td key={j}>{period===1?'Month':'Annual'} Price</td>
                  if( f?.pricemonth || f?.pricemonth === 0 ) return <td key={j}>
                    {f?.pricemonth === 0 ?
                      <><span className="txt-l">Free</span></>
                    :
                      <><span className="txt-top">&pound;</span><span className="txt-l">{period===1?f.pricemonth.toFixed(2):f.priceyear.toFixed(2)}</span> / {period===1?'Month':'Year'}</>
                    }
                  </td>
                  if( f.order ) return <td key={j}>
                    <button className="btn-pricing" onClick={()=>addToCart(f.order, period)}>Order Now</button>
                  </td>
                  return (
                    <td key={j}>
                      {f?.check&&<BsCheck2 size={20} color={'#12a16b'} className="me-2" />}
                      {f.title}
                    </td>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  return (
    <main className="main">

      <section id="hero" className="hero section dark-background">

        <div className="hero-background">
          <img src="/images/bg-14.webp" alt="" data-aos-duration="1000" />
          <div className="overlay"></div>
        </div>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="hero-content">
                {/*<span className="hero-badge">Innovative Solutions</span>*/}
                <h1>Build a Community on Multiple Platforms</h1>
                <p>Stream gaming, shows, podcasts, and music to your fans across multiple platforms.</p>
                <div className="hero-actions">
                  <a href={'#pricing'} className="btn-primary">View Pricing</a>
                </div>
                {/*<div className="hero-stats">
                  <div className="stat-item">
                    <span className="stat-number">500+</span>
                    <span className="stat-label">Streams Delivered</span>
                  </div>
                </div>*/}
              </div>
            </div>
            <div className="col-lg-5">
              <div className="hero-visual">
                <div className="row g-3">
                  <div className="col-12">
                    Full Video
                  </div>
                  <div className="col">
                    <div className="feature-card" style={{height: 60, padding: 12}}>
                      <FaFacebook size={32} color={'#12a16b'} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="feature-card" style={{height: 60, padding: 12}}>
                      <FaTwitch size={32} color={'#12a16b'} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="feature-card" style={{height: 60, padding: 12}}>
                      <FaMixcloud size={32} color={'#12a16b'} />
                    </div>
                  </div>
                  <div className="col">
                    <div className="feature-card" style={{height: 60, padding: 12}}>
                      <FaYoutube size={32} color={'#12a16b'} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="pricing" className="pricing section">
        <div className="container section-title">
          <h2>Pricing</h2>
          <div className="features">
            <div className="tab-content">
              <div className="content-box">
                <div className="highlight d-flex align-items-center justify-content-center">
                  <span>Save 10% on annual pricing.</span>
                  <span className="mx-2 btn-border">
                    <span className={period===1?'btn-custom-selected':'btn-custom'} onClick={()=>setPeriod(1)}>Month</span>
                  </span>
                  <span className="btn-border">
                    <span className={period===12?'btn-custom-selected':'btn-custom'} onClick={()=>setPeriod(12)}>Year</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row gy-4 justify-content-center">
            <Products products={restream} period={period} />
          </div>
        </div>
      </section>

      <section className="services section light-background">
        <div className="container section-title">
          <h2>Plan Comparison</h2>
          <Comparison />
        </div>
      </section>

      {/*<section>
        <div className="container">
          <Row>
            <Col>
              <div className="card">
                <div className="card-body">
                  Something
                </div>
              </div>
            </Col>
            <Col>
              <div className="card">
                <div className="card-body">
                  Something
                </div>
              </div>
            </Col>
            <Col>
              <div className="card">
                <div className="card-body">
                  Something
                </div>
              </div>
            </Col>

          </Row>
        </div>
      </section>
      <section>
        <div className="container">
          <h2>Platforms</h2>

          <div>
            Image 1 - right with tags where can stream to
            Down arrows
            Platform 1 - Platform 2 - Platform ...
            
          </div>

          <div>X+ Platforms including facebook profile, page and groups</div>
        </div>
      </section>

      <section>
        <div className="container">

          
          <h2>Web player</h2>
          <div>
            Web player and chatbox embed to display on your own website
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <h2>Works with apps / obs / ???</h2>
        </div>
      </section>

      <section>
        <div className="container">
          <h2>Analytics</h2>
        </div>
      </section>

      <section>
        <div className="container">
          <h2>Cross platform chat</h2>
        </div>
      </section>

      <section>
        <div className="container">
          <h2>Recordings</h2>
        </div>
      </section>

      <section>
        <div className="container">
          <h2>Faq</h2>
        </div>
      </section>*/}
    </main>
  );
}
